import { CellClickedEvent, ColDef } from "ag-grid-community";
import type { FhirSectionProps } from "../fhir-section";
import FhirSection from "../fhir-section";

function ProceduresSection(props: FhirSectionProps) {
  const defaultColDef: ColDef = {
    flex: 1,
    onCellClicked: (event: CellClickedEvent) => props.handleCellClick(props.sectionId, event),
    cellStyle: props.handleCellStyle,
  };

  return <FhirSection {...props} defaultColDef={defaultColDef} />;
}

export default ProceduresSection;
